export enum RoutineType {
  EMPTY = '',
  NUMERIC = 'NUMERIC',
  WEEKDAYS = 'WEEKDAYS'
}

export const RoutineTypeDB = [
  { label: 'routine.types.numeric', value: RoutineType.NUMERIC },
  { label: 'routine.types.weekdays', value: RoutineType.WEEKDAYS }
]
